import { render, staticRenderFns } from "./Analysis.vue?vue&type=template&id=4481e664&scoped=true&"
var script = {}
import style0 from "./style.scss?vue&type=style&index=0&id=4481e664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4481e664",
  null
  
)

export default component.exports